var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import NavigationService from "@ane/core/lib/services/NavigationService";
import { ROUTES } from "./Routes.constants.js";
class Util {
  constructor() {
    __publicField(this, "_modulePath", ROUTES.featureProgression.root.match.path);
    __publicField(this, "_modulePathname", ROUTES.featureProgression.root.location.pathname);
    __publicField(this, "routes", {
      root: {
        path: () => `${this.path}`,
        getURL: () => `${this.url}`
      },
      view: {
        path: () => `${this.path}${ROUTES.featureProgression.view.match.path}`,
        getURL: (id) => {
          return `${this.url}/${id}`;
        }
      },
      create: {
        path: () => `${this.path}${ROUTES.featureProgression.create.match.path}`,
        getURL: () => {
          return `${this.url}${ROUTES.featureProgression.create.location.pathname}`;
        }
      },
      progressionStageView: {
        path: () => `${this.path}${ROUTES.featureProgression.view.match.path}`,
        getURL: (id, progressionStageIds) => {
          return `${this.url}/${id}?progressionStageId=${progressionStageIds.join(",")}`;
        }
      }
    });
  }
  /**
   * React Router regex path
   */
  get path() {
    return `${NavigationService.root.path}${this._modulePath}`;
  }
  /**
   * Pathname used to construct complete URL
   */
  get url() {
    return `${NavigationService.root.url}${this._modulePathname}`;
  }
}
const FeatureProgressionRouteUtils = new Util();
export {
  FeatureProgressionRouteUtils
};
//# sourceMappingURL=FeatureProgressionRoute.utils.js.map
